import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function validateCenterFinalCosts(id: number) {
  return restApiClient.url(constructApiUrl(API.centers.validateFinalCosts.url, { id })).post()
}
